var _circle, _circle2, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 160,
    viewBox: "0 0 161 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 56.5,
    r: 5,
    stroke: "#202E5F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 102.5,
    r: 3,
    stroke: "#848A9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134 109L135.756 113.744L140.5 115.5L135.756 117.256L134 122L132.244 117.256L127.5 115.5L132.244 113.744L134 109Z",
    fill: "#E3E4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12L36.7556 16.7444L41.5 18.5L36.7556 20.2556L35 25L33.2444 20.2556L28.5 18.5L33.2444 16.7444L35 12Z",
    fill: "#E3E4E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8768_53527)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    y: 38,
    width: 84,
    height: 84,
    rx: 42,
    fill: "#E3E4E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2727 94.7501L60.7852 80.2626L64.407 76.6407L75.2727 87.5063L98.5924 64.1865L102.214 67.8084L75.2727 94.7501Z",
    fill: "#202E5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8768_53527",
    x: 17.5,
    y: 15.52,
    width: 126,
    height: 126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.48
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.0117647 0 0 0 0 0.345098 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8768_53527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8768_53527",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderSuccess);
export default __webpack_public_path__ + "static/media/placeholderSuccess.2b8cfcdb89492cc25984e61f6df51cc6.svg";
export { ForwardRef as ReactComponent };